var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:`fill-current stroke-current text-${_vm.color}`,attrs:{"viewBox":"0 0 18 12","height":`${_vm.height}px` || '12px',"width":`${_vm.width}px` || '18px'}},[_c('path',{attrs:{"d":"M1.125 1.125H16.875M1.125 6H16.875M1.125 10.875H16.875","stroke-width":"2.25","stroke-miterlimit":"10","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }